export default __webpack_public_path__ + "static/media/loader.72fcc323.svg";